var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAssetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.864 0H4.136L0 4.74v1.536l8 9.5 8-9.5V4.74zM1.1 5l3.491-4h1.288L4.716 5zm4.657 0 1.164-4h2.158l1.164 4zm5.528 0L10.12 1h1.288L14.9 5zm-.006 1h3.646l-5.73 6.804zm-1.046 0L8 13.292 5.767 6zm-3.428 6.804L4.72 6H1.075z",
  clipRule: "evenodd"
})));
export default SvgAssetIcon;